const removeTrailingSlashes = (value: string): string =>
  value.replace(/\/+$/, "");

const appEnvironment = (
  process.env.REACT_APP_ENV ||
  process.env.NODE_ENV ||
  "development"
)
  .trim()
  .toLowerCase();

export const IS_PRODUCTION =
  process.env.NODE_ENV === "production" ||
  appEnvironment === "production" ||
  appEnvironment === "prod";

/**
 * Development deliberately prioritizes the existing
 * REACT_APP_BACKEND_URL variable.
 *
 * Production prioritizes the new canonical variable.
 */
const configuredApiUrl = IS_PRODUCTION
  ? process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_PUBLIC_API_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL
  : process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_BASE_URL;

const fallbackApiUrl = IS_PRODUCTION
  ? "https://api.pickdengu.mw"
  : "http://localhost:5000";

export const API_BASE_URL = removeTrailingSlashes(
  configuredApiUrl || fallbackApiUrl,
);

export const BACKEND_URL = API_BASE_URL;
export const PUBLIC_API_BASE_URL = API_BASE_URL;

export const buildApiUrl = (path: string): string => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${API_BASE_URL}${normalizedPath}`;
};
